module.exports = __webpack_public_path__ + "img/my.dfd404b1.png";